import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M73.0076 41.0908C73.0076 41.0908 59.4476 34.2008 55.3976 29.4708C50.8976 24.2108 51.0977 1.5708 51.0977 1.5708H38.6776C38.6776 1.5708 38.9876 24.3208 34.3776 29.4708C29.4876 34.9308 16.7676 40.8908 16.7676 40.8908C22.9576 55.4708 35.3576 59.1908 44.8876 59.1908C54.4276 59.1908 66.8176 55.6808 73.0076 41.0908Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M86.5376 57.9907C84.9776 45.9807 81.3276 42.7407 76.6576 40.3907C74.3576 39.2307 59.8376 31.5107 59.8376 31.5107C59.8376 31.5107 54.9276 38.4507 45.2476 38.4507C35.5676 38.4507 29.9476 31.5107 29.9476 31.5107C29.9476 31.5107 15.5077 39.1807 13.1077 40.3907C8.43767 42.7407 4.87766 46.3707 3.22766 57.9907C1.74766 69.0507 1.30762 71.8107 1.30762 71.8107H88.4576C88.4576 71.8107 87.8476 68.2907 86.5376 57.9907Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M23.998 34.3208C23.998 34.3208 30.2481 44.5608 43.9781 44.5608C59.1681 44.5608 65.7781 34.3208 65.7781 34.3208"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        opacity="0.8"
        d="M36.2875 70.7808L36.7675 69.0108L25.9375 60.2108L39.8674 59.4608L44.8875 46.4408L49.9075 59.4608L63.8375 60.2108L53.0074 69.0108L53.4775 70.7708"
        fill="white"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="44.885"
          y1="42.7448"
          x2="44.885"
          y2="8.7121"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
